import { INITIAL_USER_REQUEST, FINAL_USER_REQUEST, FETCH_USER_SUCCESS, FETCH_USER_ERROR, DELETE_USER_SUCCESS, SAVE_USER_SUCCESS } from "../types/user.types";

const initialState = {
	users: [],
	customers: [],
	roles: [],
	quantity: 0,
	last_page: 0,
	from: 0,
	to: 0,
	isFetching: false,
	error: null,
};

function users(state = initialState, action) {
	switch (action.type) {
		case INITIAL_USER_REQUEST:
			return {
				...state,
				isFetching: true,
				error: null,
			};
		case FINAL_USER_REQUEST:
			return {
				...state,
				isFetching: false,
			};
		case FETCH_USER_SUCCESS:
			return {
				...state,
				isFetching: false,
				users: action.payload.users,
				customers: action.payload.customers,
				roles: action.payload.roles,
				quantity: action.payload.quantity,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
			};
		case FETCH_USER_ERROR:
			return {
				...state,
				isFetching: false,
				error: action.payload.error,
				users: [],
				customers: [],
				roles: [],
				quantity: 0,
				last_page: 0,
				from: 0,
				to: 0,
			};
		case DELETE_USER_SUCCESS:
			return {
				...state,
				isFetching: false,
				users: action.payload.users,
				customers: action.payload.customers,
				roles: action.payload.roles,
				quantity: action.payload.quantity,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
			};
		case SAVE_USER_SUCCESS:
			return {
				...state,
				isFetching: false,
				users: action.payload.users,
				customers: action.payload.customers,
				roles: action.payload.roles,
				quantity: action.payload.quantity,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
			};
		default:
			return state;
	}
}

export default users;
